import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as skill from '../skill'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: skill.RESOURCE.payload.dimension.partialId,
      partialId: skill.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Industry-standard code to describe the use of a room',
    isOptional: true,
    name: 'Is Certificate',
    partialId: PartialId.Standard.create('is_certificate'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
